import { render, staticRenderFns } from "./FundaIntroA.vue?vue&type=template&id=8c36f4b8&"
import script from "./FundaIntroA.vue?vue&type=script&lang=js&"
export * from "./FundaIntroA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports